import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-night pb-16" data-id="element-76" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-77" data-mp="3ggkal1dq1o2p">
        <p className="text-[0.68rem] leading-snug text-white/60" data-id="element-78" data-mp="32p5mwh8vcypb">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[0.64rem] leading-snug text-white/60" data-id="element-79" data-mp="36nd4feb5q41k">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normativa
          eléctrica, seguridad, licencias, certificaciones, permisos ni el
          criterio de un profesional habilitado. Toda práctica debe realizarse
          sobre equipos propios o expresamente autorizados y siguiendo las
          normas de seguridad aplicables.
        </p>
        <p className="mt-1 text-[0.68rem] text-white/80" data-id="element-80" data-mp="2a1jkvdfai24k">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-yellow transition-colors duration-150 ease-out hover:text-white" data-id="element-81" data-mp="2ezl5i2sd69i5">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-white/80" data-id="element-82" data-mp="3v7gfc075ga9a">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-83" data-mp="3qazrl73v3xwq">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-84" data-mp="31uoff6267ob">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-85" data-mp="ht3axfenzcx8">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-86" data-mp="qsqd43f7wmrc">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-87" data-mp="qrf9c3lrvf08">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}